module.exports = __webpack_public_path__ + "img/IMG-20191005-WA0005.e391d6fc.jpg";